export default "__VITE_ASSET__DQ5yDD4X__"